/**
 * Effects Tokens
 *
 * Visual effects tokens extracted from the design system.
 * These include blur and drop-shadow values for use in shadows, backdrop filters, etc.
 */

export const effectsTokens = {
  // Blur values (for backdrop-filter, etc.)
  blur: {
    0: '0rem',
    half: '0.03125rem',
    1: '0.0625rem',
    2: '0.125rem',
    4: '0.25rem',
    6: '0.375rem',
    8: '0.5rem',
    10: '0.625rem',
    12: '0.75rem',
    14: '0.875rem',
    16: '1rem',
    18: '1.125rem',
    20: '1.25rem',
    50: '3.125rem',
    100: '6.25rem',
  },

  // Drop shadow values (for box-shadow blur radius)
  dropShadow: {
    0: '0rem',
    1: '0.0625rem',
    2: '0.125rem',
    4: '0.25rem',
    6: '0.375rem',
    8: '0.5rem',
    10: '0.625rem',
    12: '0.75rem',
    14: '0.875rem',
    16: '1rem',
    18: '1.125rem',
    20: '1.25rem',
    40: '2.5rem',
    60: '3.75rem',
  },
} as const;

export type EffectsTokens = typeof effectsTokens;
